export const EXPORT_USERS_LABEL = {
  EXPORT_DATE: "Export Date",
  USER_NAME: "User Name",
  EMAIL_ADDRESS: "Email Address",
  USER_ROLE: "User Role",
  BUSINESS: "Business",
  MEETING_TYPES: "Meeting Types",
  DATE_ADDED: "Date Added",
  LAST_LOGIN: "Last Login"
} as const;

export const EXPORT_USERS_FORMAT = {
  DATE: "M/d/yyyy"
} as const;

export const EXPORT_USERS_FILE = {
  NAME: "Mable User List.xlsx"
} as const;

export const EXPORT_USERS_MESSAGE = {
  SUCCESS: "Export successful"
} as const;

export const EXPORT_USERS_HEADER_LABELS = [
  EXPORT_USERS_LABEL.USER_NAME,
  EXPORT_USERS_LABEL.EMAIL_ADDRESS,
  EXPORT_USERS_LABEL.USER_ROLE,
  EXPORT_USERS_LABEL.BUSINESS,
  EXPORT_USERS_LABEL.MEETING_TYPES,
  EXPORT_USERS_LABEL.DATE_ADDED,
  EXPORT_USERS_LABEL.LAST_LOGIN
] as const;
